import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Products from '../views/Products.vue'
import News from '../views/News.vue'
import Contact from '../views/Contact.vue'
import Join from '../views/Join.vue'
import store from '../store'

Vue.use(VueRouter)

// 解决重复导航到相同路由时的错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    title: '',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    title: '关于我们',
    component: About
  },
  {
    path: '/products',
    name: 'Products',
    title: '产品中心',
    component: Products
  },
  {
    path: '/contact',
    name: 'Contact',
    title: '联系我们',
    component: Contact
  },
  {
    path: '/news',
    name: 'News',
    title: '新闻资讯',
    component: News
  },
  {
    path: '/join',
    name: 'Join',
    title: '招聘信息',
    component: Join
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 全局路由守卫：在路由切换后更新页面标题
router.afterEach((to) => {
  // 尝试从路由配置中获取标题
  let title = null;

  // 首先尝试在路由记录中查找title属性
  for (let i = 0; i < to.matched.length; i++) {
    if (to.matched[i].title) {
      title = to.matched[i].title;
      break;
    }
  }

  // 如果没找到，尝试从routes数组中获取
  if (!title) {
    const routeConfig = routes.find(route => route.name === to.name);
    if (routeConfig && routeConfig.title) {
      // 从store实例获取系统设置
      const systemSettings = store.getters.systemSettings;
      title = routeConfig.title + ',' + (systemSettings && systemSettings.sitename ? systemSettings.sitename : '博奥润康(许昌)医学检验实验室');
    }
  }

  // 获取系统设置用于默认标题
  const systemSettings = store.getters.systemSettings;

  // 设置页面标题，如果还是没有则使用默认标题
  document.title = title || (systemSettings && systemSettings.sitename ? systemSettings.sitename : '博奥润康(许昌)医学检验实验室');
})

export default router